<template>
  <div v-if="isTabListVisible" class="flex-grow px-4 md:order-1 sm:px-0" id="subheaderTabs" data-testid="subheader-tabs" ref="tabsContainer">
    <Tabs
      id="layout-tabs"
      :selected-tab="selectedTab"
      @clicked="(e: any) => tabClicked(e.tab.hash as SubheaderTabs)"
      @changed="(e: any) => onTabChange(e.tab.hash as SubheaderTabs)"
    >
      <Tab class="md:mt-4" id="discussion" :hidden="!commentsEnabled" name="Discussion"><Comments @addedComment="emit('addedComment')" /></Tab>
      <Tab class="md:mt-4" id="transcriptions" :hidden="!transcriptionTabEnabled" name="Transcription"><Transcription /></Tab>
      <Tab class="md:mt-4" id="analytics" :hidden="!analyticsTabEnabled" name="Analytics"> <Analytics /> </Tab>
    </Tabs>
  </div>
</template>
<script lang="ts" setup>
import { Tab, Tabs } from '@/storybook';
import { useSubheaderTabs, SubheaderTabs } from '../composables/useSubheaderTabs';

import Comments from './item_tabs/comments/Comments.vue';
import Transcription from './item_tabs/transcription/Transcription.vue';
import Analytics from './item_tabs/analytics/Analytics.vue';
import { computed, onMounted, onUnmounted, ref } from 'vue';

const { transcriptionTabEnabled, analyticsTabEnabled, isTabListVisible, commentsEnabled, selectedTab, selectTab, onTabChange } = useSubheaderTabs();
const emit = defineEmits(['addedComment']);

const tabsContainer = ref<HTMLElement | null>(null);
const tabsInViewport = ref(false);

const checkTabsInViewport = () => {
  if (!tabsContainer.value) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      tabsInViewport.value = entry.isIntersecting;
    },
    { threshold: 0.1 } // Adjust threshold as needed
  );

  observer.observe(tabsContainer.value);

  onUnmounted(() => observer.disconnect());
};

let isMounted = false;

onMounted(() => {
  isMounted = true;
  checkTabsInViewport();
});

const tabClicked = (hash: SubheaderTabs) => {
  if (!isMounted) {
    return;
  }

  selectTab(hash);
};
</script>

<style scoped></style>
